// Matches the API rule: 2-letter uppercase country code, then 2–14 uppercase letters or digits.
export const VAT_NUMBER_PATTERN = /^[A-Z]{2}[A-Z0-9]{2,14}$/

// A VAT number for lookup, where the country code may come from a separate country field.
export const VAT_LOOKUP_PATTERN = /^(?:[A-Z]{2})?[A-Z0-9]{2,14}$/

export const VAT_NUMBER_MESSAGE =
  'Please enter a valid VAT number with a 2-letter country code followed by 2–14 letters or digits, e.g. GB123456789'

export const normalizeVatNumber = (vat: string) => vat.replaceAll(' ', '').toUpperCase()
